import { FC } from "react";
import { Box, Button, Container, Grid, TextField } from "@mui/material";

import { isEmpty } from "lodash";
import { useAdminAuthControllerForgotPassword } from "service";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { AdminForgotPasswordReqDto } from "service/api/estabrookSchemas";
import { useNavigate } from "react-router-dom";
import { makeSxStyles } from "ui";
import { AdRoutes } from "../../constants/ad-routes";
import NavLink from "../../components/nav-link";

const ForgotPasswordPage: FC = () => {
  const { mutate, isLoading } = useAdminAuthControllerForgotPassword({});
  const navigate = useNavigate();
  const styles = useStyles();

  const { values, handleChange, submitForm, handleBlur, errors } =
    useFormik<AdminForgotPasswordReqDto>({
      initialValues: {
        email: "",
      },
      validate: (values) => {
        const errors: Partial<AdminForgotPasswordReqDto> = {};
        if (!values.email) {
          errors.email = "Required";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        ) {
          errors.email = "Invalid email address";
        }
        return errors;
      },
      onSubmit: (values) =>
        mutate(
          { body: { ...values, email: values.email.toLowerCase() } },
          {
            onSuccess: () => {
              toast.success("Submitted Successfully");
              navigate(AdRoutes.login);
            },
          },
        ),
    });

  return (
    <Container maxWidth="xs">
      <Box marginBottom="60px" display="flex" justifyContent="center">
        <img src="/snowsync-logo.png" alt="logo" style={{ width: "150px" }} />
      </Box>
      <Grid container rowSpacing={4} direction="column">
        <Grid item>
          <TextField
            id="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Email"
            type="email"
            fullWidth
            error={!isEmpty(errors.email)}
          />
        </Grid>
        <Grid item xs>
          <Button
            type="submit"
            variant="contained"
            disabled={
              !isEmpty(errors.email) || isEmpty(values.email) || isLoading
            }
            fullWidth
            onClick={submitForm}
          >
            Submit
          </Button>
        </Grid>
        <Grid item xs sx={styles.linkContainer}>
          <NavLink textAlign="center" sx={styles.link} linkTo={AdRoutes.login}>
            Back To Login
          </NavLink>
        </Grid>
      </Grid>
    </Container>
  );
};

const useStyles = makeSxStyles(({ palette: { neutral } }) => ({
  linkContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  link: {
    textDecoration: "none",
    margin: "0px auto",
  },
  iconButton: { color: neutral },
}));

export default ForgotPasswordPage;
